import React from 'react';
import styled from 'styled-components'
import { connect } from 'react-redux'

import Layout from '../../components/Layout'
import ProgressBar from '../../components/ProgressBar'
import ButtonComponent from '../../components/Button';

import constants from '../../config/constants'

import result1 from '../../assets/images/01.gif'
import result2 from '../../assets/images/02.gif'
import result3 from '../../assets/images/03.gif'
import result4 from '../../assets/images/04.gif'
import result5 from '../../assets/images/05.gif'

const Main = styled.div`
  padding: 2rem 0;
`

const MainImg = styled.div`
  text-align: center;
`

const MainDetail = styled.div`
  padding-top: 1rem;
`

const Description = styled.div`
  color: ${constants.color.mediumDark} !important;
  text-align: center;
`

const Img = styled.img`
  width: 100%;
  padding: 1rem;
`

const SuitabilityTestResult = (props) => {
  let color = null;
  let images = null;
  let text = null;
  let score = props.userInfomations.suitabilityTestScore || 25;

  if(score < 15) {
    text = 'เสี่ยงต่ำ';
    color = constants.color.green;
    images = <Img alt='1' src={result1}/>;
  } else if(score >= 15 && score < 22) {
    text = 'เสี่ยงปานกลางค่อนข้างต่ำ';
    color = constants.color.green;
    images = <Img alt='2' src={result2}/>;
  } else if(score >= 22 && score < 30) {
    text = 'เสี่ยงปานกลาง';
    color = constants.color.yellow;
    images = <Img alt='3' src={result3}/>;
  } else if(score >= 30 && score < 37) {
    text = 'เสี่ยงปานกลางค่อนข้างสูง';
    color = constants.color.orange;
    images = <Img alt='4' src={result4}/>;
  } else if(score >= 37) {
    text = 'เสี่ยงสูง';
    color = constants.color.red;
    images = <Img alt='5' src={result5}/>;
  }

  return (
    <Layout title={'ผลการประเมินความเสี่ยง'} backIcon={true} onClick={() => props.history.goBack()}>
      <ProgressBar percent={75}/>
      <Main>
      <MainImg>
        {images}
      </MainImg>
      <MainDetail>
      <h3 style={{color: color, textAlign:'center'}}>{text}</h3>
        <Description style={{marginTop:'1rem', marginBottom:'2rem'}}>
          สัดส่วนการลงทุนที่แนะนำ<br/>
          กองทุนรวมตราสารหนี้ระยะสั้น  ไม่เกิน 20%<br/>
          กองทุนรวมตราสารหนี้ทั่วไป ไม่เกิน 70%<br/>
          กองทุนรวมตราสารทุน ไม่เกิน 20%<br/>
          กองทุนรวมสินทรัพย์ทางเลือก ไม่เกิน 10%
        </Description>
      </MainDetail>
      </Main>
      <ButtonComponent
        textcolor={constants.color.white}
        bordercolor={constants.color.orange}
        backgroundcolor={constants.color.orange}
        text={'ตกลง'}
        disabled={false}
        // onClick={}
        />
    </Layout>
  )
}


const mapStateToProps = (state) => {
  return {
    userInfomations: state.userInfomations
  }
}

const SuitabilityTestWithConnect = connect(mapStateToProps, null)(SuitabilityTestResult)

export default SuitabilityTestWithConnect
